import React, { useContext, useState } from "react";
import Modal from "react-modal";

import Endereco from "../Endereco";
import { StateContext } from "../../context/Context";

// ===========================================================================
// Rede de repescagem do endereço.
//
// Quem se cadastrou pelo autocadastro antes da etapa de endereço existir ficou
// sem endereço nenhum, e o Banco do Brasil recusa registrar boleto sem endereço
// do pagador — o formando só descobre isso quando o botão de gerar boleto
// falha, ou nem descobre (a rotina diária tenta em silêncio). Este aviso vai
// atrás dessas pessoas assim que elas entram no portal.
//
// Aparece só para quem tem os DOIS lados do problema: cadastro incompleto pela
// régua da API (`enderecoPendente`, a mesma do registro no BB) E boleto em
// aberto. É dispensável — quem fechar não vê de novo nesta sessão — e some
// sozinho quando o endereço é salvo, porque o próprio componente Endereco
// recarrega o cadastro no contexto.
// ===========================================================================
const CHAVE_DISPENSA = "avisoEnderecoDispensado";

function dispensadoNaSessao() {
  try {
    return window.sessionStorage.getItem(CHAVE_DISPENSA) === "1";
  } catch (e) {
    return false; // navegador sem sessionStorage: mostra (o aviso é o objetivo)
  }
}

function marcarDispensado() {
  try {
    window.sessionStorage.setItem(CHAVE_DISPENSA, "1");
  } catch (e) {
    /* sem storage: volta na próxima navegação, tudo bem */
  }
}

export default function AvisoEndereco({ financeiro }) {
  const context = useContext(StateContext);
  const [dispensado, setDispensado] = useState(dispensadoNaSessao());

  const cadastro = (context.state && context.state.cadastro) || {};
  const pendente = Boolean(cadastro.enderecoPendente);
  const faltando = cadastro.enderecoFaltando || [];

  // boleto (forma 5) visível, não pago, em qualquer contrato ativo
  const contas = financeiro || [];
  const temBoleto = contas.some(
    (ct) =>
      (ct.AlParcelas || []).some(
        (p) =>
          Number(p.parcforma) === 5 &&
          !p.parcpagoem &&
          Number(p.parcvisivel) === 1
      )
  );

  if (dispensado || !pendente || !temBoleto) return null;

  function fechar() {
    marcarDispensado();
    setDispensado(true);
  }

  return (
    <Modal
      isOpen
      onRequestClose={fechar}
      style={{
        content: {
          maxWidth: "480px",
          minWidth: "300px",
          margin: "auto",
          fontSize: "14px",
        },
      }}
    >
      <h2 style={{ marginTop: 0 }}>Complete seu endereço</h2>
      <p style={{ color: "#555" }}>
        Você tem boleto em aberto e o banco precisa do seu endereço para
        emiti-lo.
        {faltando.length > 0 && (
          <>
            {" "}
            Faltam: <strong>{faltando.join(", ")}</strong>.
          </>
        )}
      </p>

      <Endereco
        view={true}
        notificacao="Leva menos de um minuto e destrava a emissão dos seus boletos."
      />

      <button
        type="button"
        onClick={fechar}
        style={{
          width: "100%",
          padding: 10,
          marginTop: 10,
          cursor: "pointer",
        }}
      >
        Agora não
      </button>
    </Modal>
  );
}
